module.exports = __webpack_public_path__ + "static/image/weChat-h.85c30b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weChat-h.jpg
// module id = 382
// module chunks = 1